import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { forkJoin, Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Customer, CustomerInfo, Restrictions } from './Customer';
import { AppConfig } from '../../../../assets/config/appconfig';
import { AppInsightsService } from '../appinsights/appinsights.service';

@Injectable()
export class CustomerService {
  private customerURL: string;
  private restrictionURL: string;
  constructor(private http: HttpClient, private appConfig: AppConfig, private appInsightsService: AppInsightsService) {
    this.customerURL = `${this.appConfig.settings.defaultURL}/v2/customer/`;
    this.restrictionURL = `${this.appConfig.settings.defaultURL}/v2/proxy/`;
  }

  getCustomer(accountNumber : string, customerName : string, zipcode : string, action : string): Observable<Customer>{
    const url = `${this.customerURL}find`
    const queryParams = { account: accountNumber, name: customerName, zip: zipcode, optaction: action }
    this.appInsightsService.logEvent(`Calling getCustomer endpoint: ${url}`);
    return this.http.get<Customer>(url,{params:queryParams});
  }

  getCustomerDetails(accountNumber : string, customerName : string, zipcode : string, action : string): Observable<Customer>{
    const url = `${this.customerURL}getDetails`
    const httpOptions = { 
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: { accountId: accountNumber, name: customerName, zip: zipcode, optaction: action } 
    };
    this.appInsightsService.logEvent(`Calling getCustomerDetails endpoint: ${url}`);
    return this.http.get<Customer>(url, httpOptions).pipe(share());
  }
 
  isCustomerRestricted(contactIds: string[],action:string): Observable<Restrictions[]> {
        //for POST
        const url = `${this.restrictionURL}restriction`;
        this.appInsightsService.logEvent(`Calling restriction endpoint: ${url}`);
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const chunks = this.chunkArray(contactIds, 50);
         const calls = chunks.map(ids => {
             const request: CustomerInfo = {
                 cca: this.appConfig.settings.ccaName,
                 action: action,
                 contactIds: ids
             }
             return this.http.post<Restrictions[]>(url, request, httpOptions);
         });
        return forkJoin(calls).pipe(map(r => {
          return r.reduce(this.populate, [])
        }));
    }

    private populate(result: Restrictions[],apiResult: Restrictions[]): Restrictions[]
    {
      apiResult.forEach(restriction => {
        const restrictionInResult = result.find(r => r.restrictionType === restriction.restrictionType);
        if(restrictionInResult === undefined) {
          result.push(restriction);
        } else if (!restrictionInResult.isRestricted && restriction.isRestricted){
          restrictionInResult.isRestricted = restriction.isRestricted;
        }
      });
      return result;
    }

  private chunkArray(array: string[], chunkSize: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
}
